import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c-chica-apertura',
  templateUrl: './c-chica-apertura.component.html',
  styleUrls: ['./c-chica-apertura.component.scss']
})
export class CChicaAperturaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
